import styles from "./Landing.module.scss";
import Card from "../../components/card/Card";
import ImageCard from "../../components/imageCard/ImageCard";
import {Images} from "./images";


const Landing = ({shadow = false, openImageModal}) => {
  const cards = [
    {
      title: "Trädgårdspusselet",
      icon: "fa-puzzle-piece",
      text: "Känns det som att det saknas något i trädgården? Vi hjälper dig att hitta rätt pusselbit för just dig.",
    },
    {
      title: "Hållbara skötselinsatser",
      icon: "fa-arrows-rotate",
      text: "Bra för din trädgård och för planeten",
    },
    {
      title: "Trestad",
      icon: "fa-map-location-dot",
      text: "Trollhättan, Vänersborg och Uddevalla.",
    },
  ];

  return (
    <div>
      <div className={styles.start}>
        <div className={styles.jumbotron}>
          <h1>Grahns Trädgård</h1>
          <p>Trädgårdstjänster med omtanke om djur & natur</p>
        </div>
        <div className="row">
          { cards.map((card, index) => (<Card key={`card-${index}`} {...{...card, shadow: shadow}} />)) }
        </div>
      </div>
      <div className="row">
        { Images.map((image, index) => <ImageCard key={`image-${index}`} {...image} onClick={openImageModal} />)} 
      </div>
    </div>
  );
};

export default Landing;
